// What to tell the user when "Clear scenario" is refused.
//
// The clear route answers a refusal with a bare status (clearBranchPremise.js), and the
// button used to swallow it — so every refusal read as a dead button. This names the few
// statuses that route actually returns, and falls back to a plain retry line for the rest.

/**
 * The line shown under the button after a refused clear.
 *
 * @param {number|null|undefined} status HTTP status of the refused request; 0/null is a
 *   network failure (apiClient's `{ok:false,status:0}`)
 * @returns {string}
 */
export function premiseClearMessage(status) {
  switch (status) {
    case 409:
      return "Sayer hasn't finished settling this scenario yet, so it can't be cleared. Try again in a few minutes.";
    case 404:
      return "This scenario couldn't be found. It may have been deleted.";
    case 401:
      return "You've been signed out. Sign in again to clear this scenario.";
    case 403:
      return "Only the owner of this forecast can clear this scenario.";
    case 503:
      return "Sayer can't clear scenarios right now. Try again in a minute.";
    case 0:
    case null:
    case undefined:
      return "Sayer couldn't be reached. Check your connection and try again.";
    default:
      return "Couldn't clear this scenario. Try again.";
  }
}
